// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
::before,
::after {
  box-sizing: border-box;
}

svg:not([fill]) {
  fill: currentColor;
}

.link-modal-overlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 20, 31, 0.7);
  z-index: 9999;
}

.link-modal {
  width: 100%;
  max-width: 480px;
  margin: 160px auto 64px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
    'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #262b33;
}

.link-modal__search {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  cursor: text;
}

.link-modal__search-field {
  display: flex;
  align-items: center;
}

.link-modal__search-input {
  width: 100%;
  display: block;
  background-color: #fff;
  outline: none;
  border: 0;
  font-size: 18px;
  line-height: 20px;
  margin: 0;

  &::placeholder {
    color: #98a1b3;
    opacity: 1;
  }
}

.link-modal__search-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  color: #98a1b3;
}

.link-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: #98a1b3;
  transition: color 0.2s ease;

  & svg path {
    stroke: none;
  }

  &:hover {
    color: #262b33;
  }
}

.link-modal__publications {
  display: none;
  width: 100%;
  height: 100%;
  max-height: 232px;
  padding: 8px;
  border-top: 1px solid #e6ebf4;
  overflow-y: auto;

  &.is-visible {
    display: block;
  }
}

.link-modal__publication {
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;

  &:hover {
    background-color: #e6f4ff;

    & .link-modal__publication-title {
      color: #1976d2;
    }

    & .link-modal__publication-id {
      color: #71a6da;
    }
  }
}

.link-modal__publication-title {
  font-size: 14px;
  line-height: 20px;
}

.link-modal__publication-id {
  font-size: 14px;
  line-height: 20px;
  color: #98a1b3;
}

.link-modal__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f2f5fa;
  border-radius: 0 0 8px 8px;
  padding: 8px 16px;
}

.link-modal__footer-message {
  font-size: 12px;
  line-height: 16px;
  color: #98a1b3;
}

.link-modal-checkbox {
  display: block;
  position: relative;
  padding-left: 22px;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
  line-height: 20px;
  color: #505762;
}

/* Hide the browser's default checkbox */
.link-modal-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.link-modal-checkbox__checkmark {
  position: absolute;
  top: calc(50% - 8px);
  left: 0;
  height: 16px;
  width: 16px;
  border: 1px solid #dde3f0;
  background-color: #fff;
  border-radius: 3px;
}

/* When the checkbox is checked, add a blue background */
.link-modal-checkbox input:checked ~ .link-modal-checkbox__checkmark {
  background-color: #1976d2;
  border: 1px solid #1976d2;
}

/* Create the checkbox__checkmark/indicator (hidden when not checked) */
.link-modal-checkbox__checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkbox__checkmark when checked */
.link-modal-checkbox input:checked ~ .link-modal-checkbox__checkmark:after {
  display: block;
}

/* Style the checkbox__checkmark/indicator */
.link-modal-checkbox .link-modal-checkbox__checkmark:after {
  left: 5px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
`, "",{"version":3,"sources":["webpack://./src/link-modal/styles.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB;6CAC2C;EAC3C,mCAAmC;EACnC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,SAAS;;EAET;IACE,cAAc;IACd,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,2BAA2B;;EAE3B;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;;EAEhB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;;EAEf;IACE,yBAAyB;;IAEzB;MACE,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;EACF;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,8CAA8C;AAC9C;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":["*,\n::before,\n::after {\n  box-sizing: border-box;\n}\n\nsvg:not([fill]) {\n  fill: currentColor;\n}\n\n.link-modal-overlay {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(15, 20, 31, 0.7);\n  z-index: 9999;\n}\n\n.link-modal {\n  width: 100%;\n  max-width: 480px;\n  margin: 160px auto 64px;\n  background-color: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,\n    'Open Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #262b33;\n}\n\n.link-modal__search {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  cursor: text;\n}\n\n.link-modal__search-field {\n  display: flex;\n  align-items: center;\n}\n\n.link-modal__search-input {\n  width: 100%;\n  display: block;\n  background-color: #fff;\n  outline: none;\n  border: 0;\n  font-size: 18px;\n  line-height: 20px;\n  margin: 0;\n\n  &::placeholder {\n    color: #98a1b3;\n    opacity: 1;\n  }\n}\n\n.link-modal__search-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  color: #98a1b3;\n}\n\n.link-modal__close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  color: #98a1b3;\n  transition: color 0.2s ease;\n\n  & svg path {\n    stroke: none;\n  }\n\n  &:hover {\n    color: #262b33;\n  }\n}\n\n.link-modal__publications {\n  display: none;\n  width: 100%;\n  height: 100%;\n  max-height: 232px;\n  padding: 8px;\n  border-top: 1px solid #e6ebf4;\n  overflow-y: auto;\n\n  &.is-visible {\n    display: block;\n  }\n}\n\n.link-modal__publication {\n  border-radius: 6px;\n  padding: 8px;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #e6f4ff;\n\n    & .link-modal__publication-title {\n      color: #1976d2;\n    }\n\n    & .link-modal__publication-id {\n      color: #71a6da;\n    }\n  }\n}\n\n.link-modal__publication-title {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.link-modal__publication-id {\n  font-size: 14px;\n  line-height: 20px;\n  color: #98a1b3;\n}\n\n.link-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #f2f5fa;\n  border-radius: 0 0 8px 8px;\n  padding: 8px 16px;\n}\n\n.link-modal__footer-message {\n  font-size: 12px;\n  line-height: 16px;\n  color: #98a1b3;\n}\n\n.link-modal-checkbox {\n  display: block;\n  position: relative;\n  padding-left: 22px;\n  cursor: pointer;\n  user-select: none;\n  font-size: 12px;\n  line-height: 20px;\n  color: #505762;\n}\n\n/* Hide the browser's default checkbox */\n.link-modal-checkbox input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n/* Create a custom checkbox */\n.link-modal-checkbox__checkmark {\n  position: absolute;\n  top: calc(50% - 8px);\n  left: 0;\n  height: 16px;\n  width: 16px;\n  border: 1px solid #dde3f0;\n  background-color: #fff;\n  border-radius: 3px;\n}\n\n/* When the checkbox is checked, add a blue background */\n.link-modal-checkbox input:checked ~ .link-modal-checkbox__checkmark {\n  background-color: #1976d2;\n  border: 1px solid #1976d2;\n}\n\n/* Create the checkbox__checkmark/indicator (hidden when not checked) */\n.link-modal-checkbox__checkmark:after {\n  content: '';\n  position: absolute;\n  display: none;\n}\n\n/* Show the checkbox__checkmark when checked */\n.link-modal-checkbox input:checked ~ .link-modal-checkbox__checkmark:after {\n  display: block;\n}\n\n/* Style the checkbox__checkmark/indicator */\n.link-modal-checkbox .link-modal-checkbox__checkmark:after {\n  left: 5px;\n  top: 1px;\n  width: 5px;\n  height: 10px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
